
export default {
    logEvent: (e) => {},
    track: (e) => {},
    track: (e) => {},
    setUserId: (e) => {}
}